<template>
<v-select
    v-bind="$attrs"
    class="personal-account-select"
    item-text="name"
    :items="accountsItems"
    outlined
    return-object
    :value="isLocal ? value : selectedAccount"
    @change="changeAccount"
    append-icon="mdi-none"
    >
    <slot slot="prepend"></slot>
</v-select>
</template>

<script>
import {
    mapGetters,
    mapState
} from "vuex";

export default {
    name: "PersonalAccountSelect",
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        onlyIsOwner: {
            type: Boolean,
            default: true
        },
        isLocal: {
            type: Boolean,
            default: false
        },
        value: {}
    },
    computed: {
        accountsItems() {
            // console.log('accounts', this.accounts)
            if (this.onlyIsOwner) return this.accounts.filter(el => el.isOwner);
            else return this.accounts;
        },
        ...mapState("account", ["accounts", "selectedAccount"])
    },
    methods: {
        changeAccount(selectedAccount) {

            if (this.isLocal) {
                this.$emit("change", selectedAccount);
            } else {
                this.$emit('loading', true)
                this.$store.dispatch("account/selectPersonalAccount", selectedAccount);
                this.$store.dispatch("indication/loadDevices")
                    .finally(() => {
                        this.$emit('loading', false)
                    });
            }
        }
    },
    watch: {
        value: {
            immediate: true,
            handler: function (val) {
                if (!val) this.$emit("change", this.selectedAccount);
            }
        }
    }
};
</script>

<style lang="scss">
.v-select__selection--comma {
    @media screen and (max-width: 768px) {
        white-space: normal !important;
    }
}

.v-text-field.v-text-field--enclosed {
    @media screen and (max-width: 450px) {
        // flex-wrap: wrap;
    }
}
</style>
